{
  "list": {
    "title": "Customers",
    "subtitle": "{{n}} customers",
    "searchLabel": "Search customers",
    "searchPlaceholder": "Name, mobile, email",
    "new": "New customer",
    "caption": "Customers",
    "empty": {
      "title": "No customers",
      "noMatches": "No results match your search.",
      "addFirst": "Add your first customer to get started."
    },
    "columns": {
      "name": "Customer",
      "phone": "Mobile",
      "email": "Email",
      "bookings": "Bookings",
      "lastBooking": "Last booking",
      "totalPaid": "Total paid"
    }
  },
  "drawer": {
    "email": "Email",
    "bookings": "Bookings",
    "totalPaid": "Total paid",
    "linked": "Linked",
    "notLinked": "Not linked",
    "edit": "Edit",
    "bookingsTitle": "Bookings",
    "noBookings": "No bookings",
    "newBooking": "New booking for this customer"
  },
  "form": {
    "firstName": "First name",
    "lastName": "Last name",
    "phone": "Mobile number",
    "phoneHint": "The invoice and payment link are sent by SMS",
    "existing": "This customer already exists.",
    "viewExisting": "View customer",
    "email": "Email (optional)",
    "notes": "Notes",
    "saving": "Saving…",
    "save": "Save customer",
    "saved": "Changes saved",
    "created": "Customer added",
    "saveFailed": "Couldn't save",
    "errors": {
      "firstName": "First name is required",
      "lastName": "Last name is required",
      "phone": "Invalid mobile number (e.g. 5XXXXXXXX)",
      "email": "Invalid email address",
      "phoneExists": "A customer with this mobile number already exists"
    },
    "useExisting": "Use this customer"
  }
}
